import { render, staticRenderFns } from "./ButtonWidget.vue?vue&type=template&id=337062d7&scoped=true"
import script from "./ButtonWidget.vue?vue&type=script&lang=js"
export * from "./ButtonWidget.vue?vue&type=script&lang=js"
import style0 from "./ButtonWidget.vue?vue&type=style&index=0&id=337062d7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337062d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337062d7')) {
      api.createRecord('337062d7', component.options)
    } else {
      api.reload('337062d7', component.options)
    }
    module.hot.accept("./ButtonWidget.vue?vue&type=template&id=337062d7&scoped=true", function () {
      api.rerender('337062d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/ButtonWidget.vue"
export default component.exports